import { EXIF } from 'exif-js';

export default (file, fullPreview, defaultWidth = 300) =>
  new Promise(resolve => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const image = new Image();

    image.onload = () => {
      const { width, height } = image;
      const ratio = width / height;

      const PREVIEW_WIDTH = fullPreview ? width : defaultWidth;
      const PREVIEW_HEIGHT = fullPreview ? height : PREVIEW_WIDTH / ratio;

      canvas.width = PREVIEW_WIDTH;
      canvas.height = PREVIEW_HEIGHT;

      ctx.drawImage(image, 0, 0, PREVIEW_WIDTH, PREVIEW_HEIGHT);

      const isExif = EXIF.getData(image, () => {
        const orientation = EXIF.getTag(image, 'Orientation');

        ctx.save();

        if (orientation) {
          if (orientation > 4) {
            canvas.width = PREVIEW_HEIGHT;
            canvas.height = PREVIEW_WIDTH;
            canvas.style.width = PREVIEW_HEIGHT;
            canvas.style.height = PREVIEW_WIDTH;
          }

          switch (orientation) {
            case 2:
              // horizontal flip
              ctx.translate(canvas.width, 0);
              ctx.scale(-1, 1);
              break;
            case 3:
              // 180° rotate left
              ctx.translate(canvas.width, canvas.height);
              ctx.rotate(Math.PI);
              break;
            case 4:
              // vertical flip
              ctx.translate(0, canvas.height);
              ctx.scale(1, -1);
              break;
            case 5:
              // vertical flip + 90 rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.scale(1, -1);
              break;
            case 6:
              // 90° rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.translate(0, -PREVIEW_HEIGHT);
              break;
            case 7:
              // horizontal flip + 90 rotate right
              ctx.rotate(0.5 * Math.PI);
              ctx.translate(canvas.width, -canvas.height);
              ctx.scale(-1, 1);
              break;
            case 8:
              // 90° rotate left
              ctx.rotate(-0.5 * Math.PI);
              ctx.translate(-PREVIEW_WIDTH, 0);
              break;

            default:
          }
          ctx.drawImage(image, 0, 0, PREVIEW_WIDTH, PREVIEW_HEIGHT);
          ctx.restore();
        }

        canvas.toBlob(blob => resolve(blob), file.type);
      });

      if (!isExif) canvas.toBlob(blob => resolve(blob), file.type);
    };

    image.src = window.URL.createObjectURL(file);
  });



// WEBPACK FOOTER //
// ./src/utils/generateImagePreview.js